module.exports = __webpack_public_path__ + "img/culture.b902178b.jpg";